import type { LogoProps, TextItem } from '../types';

export const CANVAS_WIDTH = 800;
export const CANVAS_HEIGHT = 450;

export const FONT_SIZES = [12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 48, 56, 64, 72];
export const LINE_HEIGHTS = [0.8, 1.0, 1.2, 1.4, 1.5, 1.6, 1.8, 2.0];
export const LETTER_SPACINGS = [-2, -1.5, -1, -0.5, 0, 0.5, 1, 1.5, 2, 3, 4, 5];
export const FONT_FAMILIES = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Courier New', label: 'Courier New' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Lobster', label: 'Lobster' },
  { value: 'Open Sans', label: 'Open Sans' },
];

export const LOOP_ANIMATIONS = [
  { value: 'fade-in', label: 'Pulsing Fade' },
  { value: 'slide-up', label: 'Floating' },
  { value: 'zoom-in', label: 'Pulsing Size' },
  { value: 'rotate', label: 'Rotating' },
  { value: 'bounce', label: 'Bouncing' },
  { value: 'color-pulse', label: 'Color Pulse' },
];

export const ENTRANCE_ANIMATIONS = [
  { value: 'simple-fade', label: 'Fade In' },
  { value: 'slide-from-left', label: 'Slide From Left' },
  { value: 'slide-from-right', label: 'Slide From Right' },
  { value: 'slide-from-bottom', label: 'Slide From Bottom' },
];

export const DEFAULT_TEXT_ITEM: Omit<TextItem, 'id'> = {
  text: 'Edit me!',
  x: 50,
  y: 50,
  width: 300,
  color: '#000000',
  align: 'left',
  fontFamily: 'Arial',
  fontSize: 32,
  lineHeight: 1.2,
  letterSpacing: 0,
  animation: 'none',
  animationDuration: 0,
  animationDelay: 0,
};

export const DEFAULT_LOGO_PROPS: LogoProps = {
  x: 100,
  y: 100,
  width: 200,
  height: 200,
  animation: 'none',
};

export const ANIMATION_TYPES = [
  'none',
  'fade-in',
  'slide-up',
  'zoom-in',
  'simple-fade',
  'slide-from-left',
  'slide-from-right',
  'slide-from-bottom',
  'rotate',
  'bounce',
  'color-pulse',
] as const;
